/**
 * 根据类型生成json_LD
 */
const getStructuredJson = {
  // 文章
  article: (param) => ({
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    headline: param.title, //标题 至多110字符
    image: param.coverImg || '', //至少一张 宽高最好为6x9、4x3 1x1
    datePublished: param.createTime ? new Date(param.createTime).toISOString() : undefined, //文章的首次发布日期和时间(需为 ISO 8601 格式)
    author: {
      // 作者
      '@type': 'Organization',
      name: 'Loklok',
      url: 'https://www.loklok.top/contact'
    }
  }),
  // 影片
  movie: (param) => ({
    '@type': 'Movie',
    // url: '',
    name: param.title,
    image: param.imgUrl
    // dateCreated: '', // 时间 例:'2018-10-05'
    // director: {
    //   '@type': 'Person', // 导演类型 -个人 -组织
    //   name: '' // 导演
    // }
  }),
  // 多个文章
  articleList: (param) => {
    return param && param.length
      ? {
          '@context': 'https://schema.org',
          '@type': 'ItemList',
          itemListElement: param.map((item) => ({
            '@type': 'ListItem',
            item: getStructuredJson.article(item)
          }))
        }
      : {}
  },
  // 多个movie
  movieList: (param) => {
    return param && param.length
      ? {
          '@context': 'https://schema.org',
          '@type': 'ItemList',
          itemListElement: param.map((item, index) => {
            return {
              '@type': 'ListItem',
              position: index + 1,
              item: getStructuredJson.movie(item)
            }
          })
        }
      : {}
  },
  // 面包屑导航
  bread: (param) => {
    return param.length
      ? {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: param.map((item, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: item.name,
            item: item.path
          }))
        }
      : {}
  },
  // 多个面包屑导航
  breadList: (param) => {
    return param.length ? param.map((item) => getStructuredJson.bread(item)) : []
  }
}
export default getStructuredJson
